import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../../util/utility";

const initialState = {
  result: [],
  loading: false,
  error: false,
  errorCode: null,
  msg: null,
  success: false,
};

const resetSearchStore = (state, action) => {
  return updateObject(state, initialState);
};

const searchProductIdStart = (state, action) => {
  return updateObject(state, {
    loading: true,
  });
};

const searchProductIdSuccess = (state, action) => {
  return updateObject(state, {
    loading: false,
    error: false,
    result: action.searchResults,
    searchRequestType: action.searchRequestType,
    success: true,
  });
};

const searchProductIdFail = (state, action) => {
  return updateObject(state, {
    error: true,
    loading: false,
    errorCode: action.error,
  });
};

const downloadFileStart = (state, action) => {
  return updateObject(state, {});
};

const downloadFileSuccess = (state, action) => {
  return updateObject(state, {
    error: false,
    success: true,
  });
};

const downloadFileFail = (state, action) => {
  return updateObject(state, {
    error: true,
    errorCode: action.error,
  });
};

const sortParamsStart = (state, action) => {
  return updateObject(state, {});
};

const sortParamsSuccess = (state, action) => {
  return updateObject(state, {
    error: false,
    result: action.result,
  });
};

const sortParamsFail = (state, action) => {
  return updateObject(state, {
    error: true,
    erroCode: action.error,
  });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.RESET_SEARCH_STORE:
      return resetSearchStore(state, action);

    case actionTypes.SEARCH_PRODUCT_ID_START:
      return searchProductIdStart(state, action);

    case actionTypes.SEARCH_PRODUCT_ID_SUCCESS:
      return searchProductIdSuccess(state, action);

    case actionTypes.SEARCH_PRODUCT_ID_FAIL:
      return searchProductIdFail(state, action);

    case actionTypes.DOWNLOAD_FILE_START:
      return downloadFileStart(state, action);

    case actionTypes.DOWNLOAD_FILE_SUCCESS:
      return downloadFileSuccess(state, action);

    case actionTypes.DOWNLOAD_FILE_FAIL:
      return downloadFileFail(state, action);

    case actionTypes.SORT_PARAMS_START:
      return sortParamsStart(state, action);

    case actionTypes.SORT_PARAMS_SUCCESS:
      return sortParamsSuccess(state, action);

    case actionTypes.SORT_PARAMS_FAIL:
      return sortParamsFail(state, action);

    default:
      return state;
  }
};

export default reducer;
